import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "dropdown-toggle pointer fs10 fw600",
  style: {"background-color":"transparent","border":"none","outline":"none"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  role: "button",
  class: "fl mt5 ml8",
  style: {}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8",
  style: {}
}, "グループ詳細設定", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 ml8",
  style: {"width":"160px"}
}, "確定時Zoomアカウントを紐付け", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref: "dropdown",
    class: "",
    style: {"top":"25px","right":"-10px","position":"absolute"}
  }, {
    dropdown: _withCtx(() => [
      (_ctx.purposeType != `instant_room`)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteGroup && _ctx.deleteGroup(...args))),
            class: "fs12 pointer fw600 pad10",
            style: {"line-height":"40px","width":"220px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
              width: "16",
              height: "17",
              style: {},
              class: "fl mt5 ml5"
            }, null, 8, _hoisted_3),
            _createElementVNode("p", _hoisted_4, "グループ" + _toDisplayString(_ctx.mag ? `「${_ctx.mag.name}」` : "") + "を削除", 1),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addProfile && _ctx.addProfile(...args))),
        class: "fs12 pointer fw600 pad10",
        style: {"line-height":"40px"}
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
          width: "18",
          height: "19",
          style: {},
          class: "fl mt5 ml5"
        }, null, 8, _hoisted_6),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addZoom && _ctx.addZoom(...args))),
        class: "fs12 pointer fw600 pad10",
        style: {"line-height":"40px"}
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/logo/zoom_square.png`),
          width: "20",
          height: "20",
          style: {},
          class: "fl mt5 ml5"
        }, null, 8, _hoisted_9),
        _hoisted_10,
        _hoisted_11
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/threes.png`),
          width: "18",
          height: "18"
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 512))
}